<template>
  <div class="search-wrapper">
    <div class="input-group">
      <SearchIcon class="search-icon" />
      <input
        v-model="search"
        type="text"
        class="search search-desktop"
        :placeholder="placeholder"
      >
      <input
        v-model="search"
        type="text"
        class="search search-mobile"
        :placeholder="placeholder"
      >
      <CloseSearch v-if="search" class="close-search-icon" @click="search = null" />
    </div>
    <div class="filters">
      <slot name="filters" />
    </div>
  </div>
</template>

<script>
import { delayOnKeyup } from '../utils/helper';

import SearchIcon from '../assets/svg/icon-search.svg?vue-component';
import CloseSearch from '../assets/svg/icon-close.svg?vue-component';

export default {
  components: { SearchIcon, CloseSearch },
  props: {
    placeholder: { type: String, required: true },
  },
  data: () => ({ search: null }),
  watch: {
    search(value) {
      delayOnKeyup(() => this.$emit('search', value));
    },
  },
};
</script>

<style lang="scss">
.search-wrapper {
  margin-top: var(--spacing-28);
  margin-bottom: var(--spacing-24);
  align-items: center;
  display: flex;

  .input-group {
    position: relative;
    margin-right: 16px;
    flex: 1;

    .search-mobile {
      display: none;
    }

    .search-icon {
      position: absolute;
      top: 50%;
      left: 26px;
      margin-top: -10px;

      path {
        stroke: var(--main-light-shade-4);
      }
    }

    .close-search-icon {
      position: absolute;
      top: 50%;
      right: 26px;
      margin-top: -6px;
      cursor: pointer;
      width: 18px;
      height: 18px;

      path {
        stroke: var(--main-light-shade-3);
      }
    }

    input {
      text-indent: 52px;
      background: var(--main-light);
      border: 1px solid var(--main-light-shade-2);
      box-sizing: border-box;
      border-radius: 100px;
      height: 48px;
    }

    @include bp($bp-phone) {
      .search-mobile {
        display: block;
      }

      .search-desktop {
        display: none;
      }

      .search-icon {
        left: var(--spacing-18);
      }

      .close-search-icon {
        width: 14px;
        height: 14px;
        right: var(--spacing-16);
      }
    }
  }

  .dropdown {
    width: 100%;
    height: 100%;
    line-height: 36px;
  }
}

@include bp($bp-laptop) {
  .search-wrapper .input-group input {
    height: 40px;
  }
}

@include bp($bp-mobile) {
  .search-wrapper .input-group {
    margin-right: var(--spacing-6);
  }

  .exams-search {
    .filters {
      .__filters {
        > button {
          padding: 15px;
          height: 48px;
        }
      }
    }
  }
}
</style>
